import React, { FC, useEffect, useState } from "react";
import { Card, Collapse, FormControl } from "react-bootstrap";
import { MutatorProperty } from "../../../models/types";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faCircleInfo } from "@fortawesome/free-solid-svg-icons";
import { useMutatorState } from "../../../graphql/hooks";
import styles from "./CustomTypeCard.module.scss";
import { useTypeCardVariant } from "./leftBorderStyle";
import cx from "classnames";

interface Props {
    fieldProperty: MutatorProperty;
    typeProperty: MutatorProperty;
    getVariantByType: (type: string) => string;
    onChange: (name: string, value: string) => void;
}

const MutatorStringFieldCardImplementation: FC<Props> = ({
    fieldProperty,
    typeProperty,
    getVariantByType,
    onChange
}) => {
    const mutatorState = useMutatorState();
    const { cardClassName, renderTypeBadge } = useTypeCardVariant(
        fieldProperty.type,
        getVariantByType
    );
    const [value, updateValue] = useState(fieldProperty.value);
    const [showMeta, updateShowMeta] = useState(mutatorState.showMeta);

    useEffect(() => {
        if (showMeta !== mutatorState.showMeta) {
            updateShowMeta(mutatorState.showMeta);
        }
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [mutatorState.showMeta]);

    useEffect(() => {
        if (fieldProperty.value && fieldProperty.value !== value) {
            updateValue(fieldProperty.value);
        }
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [fieldProperty.value]);

    return (
        <Card className={`text-contrast inner-card-other ${cardClassName}`}>
            <Card.Header
                className={`d-flex align-items-center ${styles.cardHeader}`}
            >
                {fieldProperty.name}
                {renderTypeBadge()}
                {typeProperty.meta ? (
                    <div
                        className="float-end ms-auto mouseHover"
                        onClick={() => updateShowMeta(!showMeta)}
                        title="Help and additional info"
                    >
                        <FontAwesomeIcon
                            icon={faCircleInfo}
                            className={cx("ms-2", {
                                "text-disabled": !showMeta,
                                "text-muted": showMeta
                            })}
                        />
                    </div>
                ) : null}
            </Card.Header>
            <Card.Body className={`${styles.cardBody}`}>
                <FormControl
                    className={styles.inputGroup}
                    type="string"
                    placeholder="Add value"
                    value={value}
                    onChange={e => updateValue(e.target.value)}
                    onBlur={e => onChange(fieldProperty.name, e.target.value)}
                />
            </Card.Body>
            {typeProperty.meta ? (
                <Collapse in={showMeta}>
                    <div>
                        <Card.Footer className={styles.footerInfo}>
                            {typeProperty.meta.description ? (
                                <div className="bread-text text-subtle">
                                    {typeProperty.meta.description}
                                </div>
                            ) : (
                                <span className="bread-text text-subtle">
                                    No description provided.
                                </span>
                            )}
                        </Card.Footer>
                    </div>
                </Collapse>
            ) : null}
        </Card>
    );
};

export const MutatorStringFieldCard = React.memo(
    MutatorStringFieldCardImplementation
);
